/**
 * 用户列表
 */

import React from 'react';
import styled from 'styled-components';
import times from 'lodash/times';
import get from 'lodash/get';

import { hoc } from '@/lib';

import PopupRank from '../popup-rank';

type Props = {
  left: any[];
  right: any[];
};
const PkBoardUsers = (props: Props) => {
  const handlePopupRank = (camp) => {
    hoc.render(
      { tab: camp === 'left' ? 0 : 1, key: 'fightRankUsers' },
      PopupRank,
    );
  };

  return (
    <Wrap>
      {['left', 'right'].map((camp) => {
        return (
          <ul
            key={camp}
            className={`pk-users pk-users-${camp}`}
            onClick={() => handlePopupRank(camp)}
          >
            {times(3, (index) => {
              const item = get(props, `${camp}.${index}`) || {};
              const style = item.uid
                ? {
                    backgroundImage: `url(${
                      item.avatar ||
                      'https://img.sumeme.com/3/3/1559108259459.png'
                    })`,
                  }
                : {};
              return (
                <li key={index} className={`rank-${index + 1}`} style={style} />
              );
            })}
          </ul>
        );
      })}
    </Wrap>
  );
};

const Wrap = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
  .pk-users {
    display: flex;
    &-left {
      flex-direction: row-reverse;
      .rank-1:after {
        background-image: url(${require('../images/text-red-num-1.png')});
      }
      .rank-2:after {
        background-image: url(${require('../images/text-red-num-2.png')});
      }
      .rank-3:after {
        background-image: url(${require('../images/text-red-num-3.png')});
      }
    }
    &-right {
      li {
        background: rgba(66, 195, 255, 0.5)
          url(${require('../images/bg-blue-seat.png')}) no-repeat center /
          contain;
        margin: 0 0 0 8px;
      }
      .rank-1:after {
        background-image: url(${require('../images/text-blue-num-1.png')});
      }
      .rank-2:after {
        background-image: url(${require('../images/text-blue-num-2.png')});
      }
      .rank-3:after {
        background-image: url(${require('../images/text-blue-num-3.png')});
      }
    }
  }
  li {
    position: relative;
    width: 28px;
    height: 28px;
    border-radius: 100%;
    margin: 0 8px 0 0;
    background: rgba(252, 82, 255, 0.5)
      url(${require('../images/bg-red-seat.png')}) no-repeat center / contain;
    cursor: pointer;
    &:after {
      content: '';
      position: absolute;
      z-index: 2;
      left: 8px;
      bottom: 2px;
      display: block;
      width: 13px;
      height: 13px;
      background: no-repeat center / contain;
    }
  }
`;

export default PkBoardUsers;
